import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { PrismicNextImage } from '@prismicio/next';
import clsx from 'clsx';
import { FeesColumnProps } from './types';
const FeesColumn = t0 => {
  const $ = _c(7);
  const {
    rows,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx("shadow-elevation-3 min-w-[270px] rounded-lg bg-white p-6", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== rows) {
    t2 = rows.map(_temp);
    $[2] = rows;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1} data-sentry-component="FeesColumn" data-sentry-source-file="index.tsx">{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default FeesColumn;
function _temp(t0) {
  const {
    label,
    icon,
    value
  } = t0;
  return <div className="flex justify-between border-t border-gray-200 py-4 first:border-none first:pt-0 last:pb-0" key={label}><div className="flex items-center gap-5"><PrismicNextImage fallbackAlt="" className="text-primary-600 h-5.5 w-5.5" field={icon} /><p className="text-body-7 font-medium text-gray-500">{label}</p></div><p className="text-body-7 font-bold text-gray-600">{value}</p></div>;
}